import React from "react";

const Facebook = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true" 
      focusable="false"
    >
      <path
        d="M7.9486 11.1164H5.83018C5.48808 11.1164 5.38281 10.9848 5.38281 10.669C5.38281 9.81373 5.38281 8.93216 5.38281 8.07689C5.38281 7.73479 5.51439 7.60321 5.83018 7.60321H7.9486V5.72163C7.92229 4.89268 8.11965 4.05058 8.52755 3.30058C8.96176 2.55058 9.64597 1.99794 10.4354 1.72163C10.9749 1.52426 11.5012 1.44531 12.067 1.44531H14.1591C14.4618 1.44531 14.5933 1.57689 14.5933 1.87952V4.31373C14.5933 4.61637 14.4618 4.74794 14.1591 4.74794C13.5802 4.74794 13.0012 4.74794 12.4223 4.77426C11.8433 4.80058 11.5407 5.05058 11.5407 5.65584C11.5144 6.30058 11.5407 6.919 11.5407 7.57689H14.0012C14.3433 7.57689 14.4749 7.70847 14.4749 8.05058V10.6427C14.4749 10.9848 14.3697 11.1164 14.0012 11.1164H11.567V18.0769C11.567 18.4453 11.4354 18.5637 11.0802 18.5637H8.40913C8.09334 18.5637 7.96176 18.4322 7.96176 18.1164V11.1164H7.9486Z"
        fill="white"
      />
    </svg>
  );
};

export default Facebook;
